import React, { useState } from 'react';
import { Card, FormTextarea, Button } from '../../../../components/ui';
import { SectionTitle } from '../../../../components/ui/Typography';

export const FinalQuotationApprovalForm = ({ initialData = {}, onSubmit, onCancel, loading = false, hideActions = false, commonNotes, notesValue }) => {
  const [formData, setFormData] = useState({
    notes: notesValue || ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Card padding="md" className="animate-in fade-in slide-in-from-bottom-2">
      <div className="space-y-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex flex-col">
            <SectionTitle>Final Quotation Approval</SectionTitle>
          </div>
        </div>

        {commonNotes ? commonNotes : (
          <FormTextarea
            label="Approval Notes"
            name="notes"
            placeholder="Any specific comments from the customer..."
            value={formData.notes || ''}
            onChange={handleChange}
            rows={3}
            size="sm"
            labelClassName="label text-xs"
            inputClassName="input text-sm"
          />
        )}

        {!hideActions && (
          <div className="flex gap-3 pt-6 mt-6 border-t border-slate-50">
            <Button
              type="button"
              onClick={handleSubmit}
              loading={loading}
              className="bg-black hover:bg-gray-900 text-white flex-1 py-2.5 flex items-center justify-center gap-2 rounded-lg"
            >
              Request Approval
            </Button>
            {onCancel && (
              <Button
                onClick={onCancel}
                variant="secondary"
                className="px-6 py-2.5 text-slate-600 border-slate-200 hover:bg-transparent hover:text-slate-800 focus:bg-transparent active:bg-transparent shadow-none"
              >
                Cancel
              </Button>
            )}
          </div>
        )}
      </div>
    </Card>
  );
};

export default FinalQuotationApprovalForm;
